import { BoxProps, styled } from "@mui/material";
import { Box } from "@mui/system";

type ActiveMenuBoxProps = BoxProps & {
    active: number;
};
const ActiveMenuBox = styled(Box)<ActiveMenuBoxProps>(({ theme, active }) => ({
    position: "absolute",
    backgroundColor: theme.palette.background.default,
    left: 0,
    right: 0,
    height: 58,
    top: active * 58 + 84 + 8,
    borderRadius: theme.custom.borderRadius.activeMenuItem,
    transition: theme.transitions.create("all", {
        easing: theme.transitions.easing.easeIn,
        duration: theme.transitions.duration.leavingScreen,
    }),
    // animation: "1s ease-out 0s 1 bounceInRight",
    "& .right-top-container": {
        position: "absolute",
        top: -40,
        right: 0,
        backgroundColor: theme.palette.background.default,
        height: 40,
        width: 40,
    },
    "& .right-top": {
        position: "relative",
        width: "100%",
        height: "100%",
        backgroundColor: theme.custom.background.menu,
        borderRadius: "0 0 50% 0",
    },

    "& .right-bottom-container": {
        position: "absolute",
        bottom: -40,
        right: 0,
        backgroundColor: theme.palette.background.default,
        height: 40,
        width: 40,
    },
    "& .right-bottom": {
        position: "relative",
        width: "100%",
        height: "100%",
        backgroundColor: theme.custom.background.menu,
        borderRadius: "0 50% 0 0",
    },
}));

type ActiveMenuProps = {
    activeIndex: number;
};
const ActiveMenu = ({ activeIndex }: ActiveMenuProps) => {
    return (
        <ActiveMenuBox className="acive-menu-item" active={activeIndex}>
            <div className="right-top-container">
                <div className="right-top"></div>
            </div>

            <div className="right-bottom-container">
                <div className="right-bottom"></div>
            </div>
        </ActiveMenuBox>
    );
};

export default ActiveMenu;
